export function isScrollPath(path: string): boolean {
  return path === "/" || path === "/scroll" || path === "/scroll/"
}
